import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import DonateModal from "./DonateModal";
import { useSmoothScroll } from "../lib/useSmoothScroll";

function scrollToHash(hash) {
  const id = decodeURIComponent(hash.slice(1));
  let tries = 0;
  const attempt = () => {
    const el = document.getElementById(id);
    if (!el) {
      if (tries++ < 30) setTimeout(attempt, 60);
      return;
    }
    const header = document.querySelector('[data-testid="site-header"]');
    const offset = header ? header.offsetHeight + 12 : 140;
    if (window.__lenis) {
      window.__lenis.scrollTo(el, { offset: -offset, duration: 1.1 });
    } else {
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };
  attempt();
}

export default function Layout() {
  useSmoothScroll();
  const { pathname, hash, key } = useLocation();
  const [donate, setDonate] = useState({ open: false, amount: 950 });

  useEffect(() => {
    const handler = (e) => setDonate({ open: true, amount: e.detail?.amount || 950 });
    window.addEventListener("open-donate", handler);
    return () => window.removeEventListener("open-donate", handler);
  }, []);

  useEffect(() => {
    if (hash) {
      scrollToHash(hash);
    } else if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, key]);

  return (
    <div className="min-h-screen bg-parchment text-indigo flex flex-col">
      <Header />
      <main className="flex-1 w-full" style={{ paddingTop: "var(--header-h, 160px)" }}>
        <Outlet />
      </main>
      <Footer />
      <DonateModal open={donate.open} onClose={() => setDonate((d) => ({ ...d, open: false }))} defaultAmount={donate.amount} />
    </div>
  );
}
